<template>
  <div>
    <!--loading screen when add video request is being handled-->
    <LoadingScreen :loading="loading" />
    <Dialog
      :title="'Are you sure you want to delete this item?'"
      :text="'This action is not reversible.'"
      :rejectButtonText="'No'"
      :acceptButtonText="'Yes'"
      :toggle="dialog"
      @reject="dialog = false"
      @accept="confirmDeleteItem"
    />
    <div class="main-panel">
      <v-row>
        <v-col cols="12" md="6" class="pt-0">
          <div class="header text-left">Manage Messages</div>
        </v-col>
        <v-col cols="12" md="6" class="action-buttons pt-0">
          <v-btn class="filter-btn" color="#FDBB30">Filter</v-btn>
          <v-btn class="create-btn" color="#00457C" @click="navCreateMessages"
            >Create Message</v-btn
          >
        </v-col>
      </v-row>

      <!-- Table -->
      <TableComponent
        type="messages"
        v-bind:dynamicHeaders="dynamicHeaders"
        v-bind:dynamicWidths="dynamicWidths"
        v-bind:dynamicRowsDetail="dynamicRowsDetail"
        v-on:view-item="viewMsg"
        v-on:edit-item="editMsg"
        v-on:delete-item="openDeleteDialog"
        v-on:view-item-analytics="viewAnalytics"
      />
    </div>

    <!-- Dialog View -->
    <div
      v-if="currentMessageView !== null"
      class="dialog-msg-wrapper dialog-screen-wrapper"
    >
      <div class="content">
        <div class="close-section">
          <span class="close-btn" v-on:click="closeMsgDialog">Close</span>
        </div>
        <v-img
          alt="msg image"
          class="image-section"
          contain
          :src="currentMessageView.imgUrl"
          transition="scale-transition"
        />
        <div class="title-section">{{ currentMessageView.title }}</div>
        <div class="start-date-section">
          {{ getDisplayDate(currentMessageView.startDate._seconds * 1000) }}
        </div>
        <div class="desc-section" v-html="currentMessageView.content"></div>
        <div class="action-section" v-if="currentMessageView.btnTitle !== ''">
          <div
            v-on:click="openNewPage(currentMessageView.redirectUrl)"
            class="action-btn"
          >
            {{ currentMessageView.btnTitle }}
          </div>
        </div>
      </div>
    </div>

    <!-- Dialog View -->
    <div
      v-if="currentMessageAnalytics !== null"
      class="dialog-ann-wrapper dialog-screen-wrapper"
    >
      <div class="content-analytics">
        <div class="close-section">
          <span class="close-btn" v-on:click="closeMsgDialog">Close</span>
        </div>
        <div class="title-section-analytics">
          <v-row>
            <v-col>
              <h4>Unique users (Read):</h4>
            </v-col>
            <v-col>
              {{ countUsers }}
            </v-col>
          </v-row>
        </div>
        <hr />
        <div class="title-section-analytics">
          <v-row>
            <v-col>
              <h4>No. of users included:</h4>
            </v-col>
            <v-col>
              {{ currentMessageAnalytics.userGuids.length }}
            </v-col>
          </v-row>
        </div>
        <hr />
        <div class="title-section-analytics">
          <v-row>
            <v-col>
              <h4>Notification Title</h4>
            </v-col>
            <v-col>
              {{ currentMessageAnalytics.notif_title }}
            </v-col>
          </v-row>
        </div>
        <hr />
        <div class="title-section-analytics">
          <v-row>
            <v-col>
              <h4>Notification Content</h4>
            </v-col>
            <v-col>
              <div v-html="currentMessageAnalytics.notif_content"></div>
            </v-col>
          </v-row>
        </div>
        <hr />
        <div class="title-section-analytics">
          <v-row>
            <v-col>
              <h4>Inbox Title</h4>
            </v-col>
            <v-col>
              {{ currentMessageAnalytics.title }}
            </v-col>
          </v-row>
        </div>
        <hr />
        <div class="title-section-analytics">
          <v-row>
            <v-col>
              <h4>Start Date:</h4>
            </v-col>
            <v-col>
              {{
                getDisplayDate(
                  currentMessageAnalytics.startDate._seconds * 1000
                )
              }}
            </v-col>
          </v-row>
        </div>
        <hr />
        <div class="title-section-analytics">
          <v-row>
            <v-col>
              <h4>End Date:</h4>
            </v-col>
            <v-col>
              {{
                getDisplayDate(currentMessageAnalytics.endDate._seconds * 1000)
              }}
            </v-col>
          </v-row>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TableComponent from "./commons/TableComponent";
import moment from "moment";
import Axios from "axios";
import Dialog from "./commons/Dialog";
import LoadingScreen from "./commons/LoadingScreen";

export default {
  components: {
    TableComponent,
    Dialog,
    LoadingScreen,
  },
  data() {
    return {
      itemDeleteId: null,
      dialog: false,
      dynamicHeaders: [
        { text: "Title", value: "title" },
        { text: "Start Date", value: "startDate" },
        { text: "End Date", value: "endDate" },
        { text: "Actions", value: "actions" },
      ],
      dynamicWidths: ["130px", "90px", "90px"],
      dynamicRowsDetail: [],
      rawMsgDetails: [],
      currentMessageView: null,
      currentMessageAnalytics: null,
      loading: false,
      countUsers: 0,
    };
  },
  created() {
    // Fetch all announcements
    Axios.get(process.env.VUE_APP_HOST_SERVER + "/api/messages/get_all").then(
      (res) => {
        console.log("Successfully retrieved all details");
        this.rawMsgDetails = res.data;
        this.dynamicRowsDetail = this.processFetchedData(res.data);
      }
    );
  },
  methods: {
    getDisplayDate(date) {
      return moment(date).format("DD MMM YYYY");
    },
    processFetchedData(rawMsgData) {
      return rawMsgData.map(({ _id, title, startDate, endDate }) => {
        return {
          rowId: _id,
          title: title,
          startDate: this.getDisplayDate(startDate._seconds * 1000),
          endDate: this.getDisplayDate(endDate._seconds * 1000),
          action: { view: "show", delete: "show", analytics: "show" },
        };
      });
    },
    navCreateMessages() {
      this.$store.dispatch("loadView", "AddMessages");
    },
    viewMsg(id) {
      this.currentMessageView = this.rawMsgDetails.find(
        (item) => item._id == id
      );
    },
    closeMsgDialog() {
      this.currentMessageView = null;
      this.currentMessageAnalytics = null;
      this.countUsers = 0;
    },
    editMsg(id) {
      this.$router
        .push({ name: "EditMessages", params: { itemId: id } })
        .catch(() => {});
    },
    confirmDeleteItem() {
      this.loading = true; //enable loading screen once user clicks delete
      this.dialog = false;
      // Update MongoDB
      Axios.delete(
        process.env.VUE_APP_HOST_SERVER +
          `/api/messages/delete/${this.itemDeleteId}`
      ).then((res) => {
        // Update client data and delete image from S3
        const imgUrlToDelete = this.rawMsgDetails.find(
          (item) => item._id == this.itemDeleteId
        ).imgUrl;
        this.dynamicRowsDetail = this.dynamicRowsDetail.filter(
          (rowDetail) => rowDetail.rowId !== res.data._id
        );
        Axios.delete(process.env.VUE_APP_HOST_SERVER + "/api/file/delete", {
          data: { s3Url: imgUrlToDelete },
        }).then((res) => {
          this.loading = false; //disable loading screen once request is handled
          console.log(res.data);
        });
        this.itemDeleteId = null;
      });
    },
    openDeleteDialog(id) {
      this.dialog = true;
      this.itemDeleteId = id;
    },
    openNewPage(redirectUrl) {
      window.open("http://" + redirectUrl);
    },
    viewAnalytics(id) {
      var count = 0;
      this.currentMessageAnalytics = this.rawMsgDetails.find(
        (item) => item._id == id
      );

      for (
        var i = 0;
        i < Object.keys(this.currentMessageAnalytics.msgContent).length;
        i++
      ) {
        if (this.currentMessageAnalytics.msgContent[i].includes("read")) {
          this.countUsers = ++count;
        }
      }
      // this.currentMessageAnalytics.msgContent.map((i) => {
      //   i.forEach((item) => {
      //     if (item.includes("read")) {
      //       console.log(count++);
      //     }
      //   });
      // });
    },
  },
};
</script>

<style>
.main-panel {
  width: 100%;
}

/* View Announcement Dialog */
.dialog-msg-wrapper .content {
  width: 400px;
  height: 800px;
  padding: 24px;
  background-color: white;
  display: flex;
  flex-direction: column;
  overflow: scroll;
}

.dialog-msg-wrapper .close-section {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding-bottom: 10px;
}

.dialog-msg-wrapper .close-section .close-btn {
  cursor: pointer;
  color: #ea6254;
  font-size: 11px;
  font-weight: bold;
}

.dialog-msg-wrapper .image-section {
  flex-basis: 170px;
}

.dialog-msg-wrapper .title-section {
  padding-top: 15px;
  text-align: start;
  font-size: 15px;
  font-weight: bold;
}

.dialog-msg-wrapper .start-date-section {
  text-align: start;
  font-size: 9px;
  padding-top: 0px;
  color: #9b9b9b;
  font-weight: bold;
}

.dialog-msg-wrapper .desc-section {
  text-align: start;
  padding-top: 10px;
  font-size: 9px;
  color: #9b9b9b;
  flex-grow: 1;
}

.dialog-msg-wrapper .action-section {
  flex-basis: 50px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.dialog-msg-wrapper .action-btn {
  width: fit-content;
  font-size: 12px;
  padding: 5px 15px 5px 15px;
  background-color: #204281;
  color: white;
  border-radius: 20px;
  cursor: pointer;
}
</style>
